import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_BEFORE_START_CALLOUT,
  PRE_ACTIVATION_BEFORE_START_INTRO,
  PRE_ACTIVATION_BEFORE_START_LABEL,
  PRE_ACTIVATION_BEFORE_START_TITLE,
} from "../../../i18n/keysTranslations";
import { PRE_ACTIVATION_BEFORE_START_TIPS } from "../../../utils/constants";
import CalloutBox from "../components/CalloutBox";
import Card from "../components/Card";
import NumberedTipsList from "../components/NumberedTipsList";

const AgencyBeforeStartSection = () => {
  const { t } = useTranslation();

  return (
    <Card section={t(PRE_ACTIVATION_BEFORE_START_LABEL)}>
      <Typography
        component="h2"
        sx={{
          fontSize: "18px",
          fontWeight: 800,
          color: "text.primary",
          letterSpacing: "-0.3px",
          lineHeight: 1.3,
          marginBottom: "10px",
        }}
      >
        {t(PRE_ACTIVATION_BEFORE_START_TITLE)}
      </Typography>
      <Typography
        sx={{
          fontSize: "13px",
          color: "text.secondary",
          lineHeight: 1.6,
          marginBottom: "24px",
        }}
      >
        {t(PRE_ACTIVATION_BEFORE_START_INTRO)}
      </Typography>
      <NumberedTipsList tips={PRE_ACTIVATION_BEFORE_START_TIPS} />
      <CalloutBox sx={{ marginTop: "24px" }}>
        {t(PRE_ACTIVATION_BEFORE_START_CALLOUT)}
      </CalloutBox>
    </Card>
  );
};

export default AgencyBeforeStartSection;
